import { createItemsData } from '../utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const domainService = new Service('/users/domains', HALApiService, createItemsData)
